import { randNumber } from '@ngneat/falso';
import { ILabDimension } from '@principle-theorem/reporting/interfaces';
import {
  MockGenerator,
  toSerialisedTimestamp,
  toTimestamp,
} from '@principle-theorem/shared';
import {
  BigQueryFirestoreModelMock,
  BigQueryInteractionMock,
  BigQueryNoteMock,
} from './common.mock';

export class LabDimensionMock
  extends BigQueryFirestoreModelMock<ILabDimension>
  implements ILabDimension
{
  timestamp = toSerialisedTimestamp(toTimestamp());
  name = 'Mock Lab';
  email = 'lab@example.com';
  address = '123 Lab Street';
  phone = '0400000000';
  mobileNumber = '0412345678';
  jobTitle = 'Lab Technician';
  labJobTypes = [
    {
      ...MockGenerator.generate(BigQueryFirestoreModelMock),
      name: 'Crown',
      cost: randNumber({ min: 50, max: 500 }),
    },
    {
      ...MockGenerator.generate(BigQueryFirestoreModelMock),
      name: 'Bridge',
      cost: randNumber({ min: 50, max: 500 }),
    },
  ];
  notes = [
    MockGenerator.generate(BigQueryNoteMock),
    MockGenerator.generate(BigQueryNoteMock),
  ];
  interactions = [
    MockGenerator.generate(BigQueryInteractionMock),
    MockGenerator.generate(BigQueryInteractionMock),
    MockGenerator.generate(BigQueryInteractionMock),
  ];
}
